import { render } from "./ChatBody.vue?vue&type=template&id=25205f3a&scoped=true"
import script from "./ChatBody.vue?vue&type=script&lang=js"
export * from "./ChatBody.vue?vue&type=script&lang=js"

import "./ChatBody.vue?vue&type=style&index=0&id=25205f3a&lang=scss"
import "./ChatBody.vue?vue&type=style&index=1&id=25205f3a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25205f3a"],['__file',"webpack-assets/vue/templates/chat/parts/ChatBody.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25205f3a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25205f3a', __exports__)) {
    api.reload('25205f3a', __exports__)
  }
  
  module.hot.accept("./ChatBody.vue?vue&type=template&id=25205f3a&scoped=true", () => {
    api.rerender('25205f3a', render)
  })

}


export default __exports__